var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.hasProviderSelection ? _c('div', {
    staticClass: "\n    d-flex\n    s-p-3 s-border-b s-border-gray-light\n    bg-white\n    justify-content-between\n    align-items-center\n  "
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.selectedOption,
      expression: "selectedOption"
    }],
    staticClass: "form-control",
    on: {
      "change": [function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.selectedOption = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }, _vm.onProviderChange]
    }
  }, _vm._l(_vm.providerSelectOptions, function (option) {
    return _c('option', {
      key: option.key || option.provider,
      domProps: {
        "value": option
      }
    }, [_vm._v(" " + _vm._s(option.title) + " ")]);
  }), 0)]) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }